import { Box, Stack } from "@mui/material";
import React from "react";

import { GroundlightImageQuery } from "features/groundlightImageQuery/GroundlightImageQuery";
import { ListResponse } from "types/api";
import { Detector } from "types/detectors";
import { ImageQuery } from "types/imageQueries";
import { LabelValue } from "types/labelValue";

import { ImageQueryPanelSkeleton } from "./ImageQueryPanelSkeleton";
import { LabelTable } from "./LabelTable";

export interface ImageQueryPanelProps {
  loading: boolean;
  data: ImageQuery | undefined;
  onSendLabel: () => Promise<void>;
  detector: Detector;
  dataLabels?: ListResponse<LabelValue>;
  loadingLabels: boolean;
  onUnsavedAnnotationsHandled: (confirmed: boolean) => void;
  onLabelSelected: (rowId: number) => void;
  selectedLabelValue?: LabelValue | null;
  bestPredictionLabelId?: number | null;
}

export function ImageQueryPanel(props: ImageQueryPanelProps) {
  const {
    loading,
    data,
    onSendLabel,
    detector,
    dataLabels,
    loadingLabels,
    onUnsavedAnnotationsHandled,
    onLabelSelected,
    selectedLabelValue,
    bestPredictionLabelId,
  } = props;

  const labelRows = dataLabels && dataLabels.results.length > 0 ? dataLabels.results : [];

  if (loading) {
    return <ImageQueryPanelSkeleton />;
  }

  return (
    <Stack sx={{ display: "flex", height: "100%", flexDirection: "column" }}>
      <Box sx={{ flexGrow: 1, minHeight: "300px" }}>
        <GroundlightImageQuery
          enablePanZoom
          data={data}
          detector={detector}
          onSendLabel={onSendLabel}
          loading={loading || loadingLabels}
          labelRows={labelRows}
          showUnsavedAnnotationsWarning
          onUnsavedAnnotationsHandled={onUnsavedAnnotationsHandled}
          roisToDisplay={selectedLabelValue?.rois}
          selectedLabelValue={selectedLabelValue}
        />
      </Box>
      {/* Keep the height of the label table at 202px to avoid weird mini scrolls */}
      <Box className="h-[202px] mt-[10px] overflow-auto" sx={{ display: { xs: "none", sm: "block" } }}>
        <LabelTable
          loading={loadingLabels}
          labelRows={labelRows}
          detector={detector}
          onLabelSelected={onLabelSelected}
          bestPredictionLabelId={bestPredictionLabelId}
          selectedLabelId={selectedLabelValue?.id}
        />
      </Box>
    </Stack>
  );
}
